








































































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { map } from '@/store/modules'
import ScrollList from '@/components/ScrollList.vue'
import NewsCard from '@/components/NewsCard.vue'
import Feature, { FeatureLike } from 'ol/Feature'
import { Commune } from '@/orrm/model/commune'
import { Phenomene } from '@/orrm/model/phenomene'
import { Departement } from '@/orrm/model/departement'
import { Actualite } from '@/orrm/model/actualite'
import { InfoReglementation } from '@/orrm/model/info-reglementation'
import config from '@/config'
import LayerDataTable from '@/components/LayerDataTable.vue'
import { RawLocation } from 'vue-router'
import BigInfo from '@/components/BigInfo.vue'
import { Geometry } from 'ol/geom'
import DotsLoader from '@/components/DotsLoader.vue'

@Component({
  components: { BigInfo, LayerDataTable, NewsCard, ScrollList, DotsLoader }
})
export default class SelectionInfoList extends Vue {
  tab = 'donnees'

  get loading () {
    return map.loading
  }

  get features () {
    return map.features
  }

  get layersData () {
    return map.layersData.filter(ld => ['donnees', null].indexOf(ld.rubric || null) !== -1)
  }

  get actualitesFeatures () {
    return map.actualites
  }

  get infosFeatures () {
    return map.infoReglementations
  }

  get entitiesFeatures () {
    return map.entities
  }

  get actualites () {
    return [
      ...this.actualitesFeatures.map((feature: FeatureLike) => feature.get('item')),
      ...map.layersData.filter(ld => ld.rubric === 'actualites')
    ]
  }

  get infos () {
    return [
      ...this.infosFeatures.map((feature: FeatureLike) => feature.get('item')),
      ...map.layersData.filter(ld => ld.rubric === 'info_reglementation')
    ]
  }

  get entities () {
    return [
      ...this.entitiesFeatures,
      ...map.layersData.filter(ld => ld.rubric === 'entites')
    ]
  }

  get orrmUrl (): string {
    return config.orrm.siteURL
  }

  created () {
    const urlParts = document.URL.split('#')
    const anchor = urlParts.length > 1 ? urlParts[1] : null

    if (anchor) {
      // URL Anchor will force-select the tab
      this.tab = anchor
    } else {
      this.targetFilledTab()
    }
  }

  @Watch('layersData')
  @Watch('entities')
  @Watch('infos')
  @Watch('actualites')
  onContentChanged () {
    this.targetFilledTab()
  }

  targetFilledTab () {
    // tab will be determinated by the first with data to display
    if (this.layersData.length) {
      this.tab = 'donnees'
    } else if (this.entities.length) {
      this.tab = 'entites'
    } else if (this.infos.length) {
      this.tab = 'infos'
    } else if (this.actualites.length) {
      this.tab = 'actualites'
    }
  }

  processActualitesTags (item: Actualite) {
    const tags: string[] = []
    item.getDepartements().map((tag: Departement) => tag.name).forEach((tag: string) => {
      tags.push(tag)
    })
    item.getCommunes().map((tag: Commune) => tag.name).forEach((tag: string) => {
      tags.push(tag)
    })
    item.getPhenomenes().map((tag: Phenomene) => tag.name).forEach((tag: string) => {
      tags.push(tag)
    })
    return tags
  }

  processInfoTags (item: InfoReglementation) {
    const tags: string[] = []
    tags.push(item.getDepartement().name)
    tags.push(item.getCommune().name)
    // tags.push(item.getPhenomene().name)
    return tags
  }

  focusOnFeatures (features: FeatureLike[]) {
    map.focusOnFeatures(features)
  }

  clearPersistance (features: Feature<Geometry>[]) {
    for (const feature of features) {
      feature.unset('persistant')
      feature.unset('focus')
      feature.changed()
    }
  }

  @Watch('features', { deep: true })
  onFeaturesChanged (newVal: Feature<Geometry>[], oldVal?: Feature<Geometry>[]) {
    if (!oldVal) return
    const toUnpersist = oldVal.filter((oldFeature: Feature<Geometry>) => newVal.indexOf(oldFeature) === -1)
    this.clearPersistance(toUnpersist)
  }

  beforeRouteLeave (to: RawLocation, from: RawLocation, next: Function) {
    this.clearPersistance(this.features as Feature<Geometry>[])
    this.features.splice(0, this.features.length)
    next()
  }
}
